export const environment = {
  production: true,
  defaultauth: 'fakebackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  apiUrl: "https://stage-api.fastband-develop.com/api/",
  forgotPaswordMailUrl: "https://fastband-develop.com/",
  user_setup_link: "https://fastband-develop.com/auth/user-setup-password/",
  socket_url: "https://socket.fastband-develop.com",
  user_reset_link: "https://fastband-develop.com/auth/user-reset-password/",
  cloudfront_url: 'd2ccdg5uhattkj.cloudfront.net'
};
